import { UserNotificationMetaType } from '@/modules/notification/constants/UserNotificationMetaType';
import { NotificationTaskAssignedMeta } from '@/modules/notification/models/meta/NotificationTaskAssignedMeta';
import { NotificationTaskChangedStatusMeta } from '@/modules/notification/models/meta/NotificationTaskChangedStatusMeta';
import { NotificationEstateStatusUpdatedMeta } from '@/modules/notification/models/meta/NotificationEstateStatusUpdatedMeta';

export class NotificationMetaFactory {
  static build(
    metaType: UserNotificationMetaType | undefined,
    model = {}
  ): NotificationEstateStatusUpdatedMeta | NotificationTaskAssignedMeta | NotificationTaskChangedStatusMeta | undefined {
    switch (metaType) {
      case UserNotificationMetaType.NOTIFICATION_ESTATE_STATUS_UPDATED_META:
        return new NotificationEstateStatusUpdatedMeta(model);
      case UserNotificationMetaType.NOTIFICATION_TASK_ASSIGNED_META:
        return new NotificationTaskAssignedMeta(model);
      case UserNotificationMetaType.NOTIFICATION_TASK_CHANGED_STATUS_META:
        return new NotificationTaskChangedStatusMeta(model);
      default:
        return undefined;
    }
  }
}
